<div class="navbar-header">

    <div class="logo">
        <img style="width:90%" src="assets/images/newLogo.png">
        <!--<h1 *ngIf="organizationName">{{organizationName}}</h1>-->
    </div>

    <!--<button mat-button class="toggle-button-navbar mat-icon-button" fuseNavbarVertical="toggleFold" fxHide.lt-lg>-->
        <!--<mat-icon>menu</mat-icon>-->
    <!--</button>-->

    <!--<button mat-button class="toggle-button-navbar mat-icon-button" fuseNavbarVertical="closeBar" fxHide.gt-md>-->
        <!--<mat-icon>arrow_back</mat-icon>-->
    <!--</button>-->

</div>

<div class="navbar-content">
    <fuse-navigation layout="vertical"></fuse-navigation>
</div>
